// extracted by mini-css-extract-plugin
export var $animation_name = "Billboard-module--$animation_name--34472";
export var Billboard = "Billboard-module--Billboard--cfd17";
export var BillboardImage = "Billboard-module--BillboardImage--89d8a";
export var BillboardSplitSection = "Billboard-module--BillboardSplitSection--901ba";
export var BillboardSplitSection__media = "Billboard-module--BillboardSplitSection__media--c7091";
export var BillboardSplitSection__textInner = "Billboard-module--BillboardSplitSection__textInner--ad470";
export var Billboard___isVisible = "Billboard-module--Billboard___isVisible--94d72";
export var Billboard__black = "Billboard-module--Billboard__black--49d91";
export var Billboard__blurb = "Billboard-module--Billboard__blurb--67cf0";
export var Billboard__red = "Billboard-module--Billboard__red--2bf5d";
export var Billboard__subTitle = "Billboard-module--Billboard__subTitle--eb164";
export var Billboard__title = "Billboard-module--Billboard__title--c714d";
export var Billboard__withImage = "Billboard-module--Billboard__withImage--b7af0";
export var Billboard__withImage___LTR = "Billboard-module--Billboard__withImage___LTR--56f05";
export var Billboard__withImage___RTL = "Billboard-module--Billboard__withImage___RTL--b194f";
export var Billboard__withoutImage = "Billboard-module--Billboard__withoutImage--cb535";
export var Billboard__yellow = "Billboard-module--Billboard__yellow--0d223";
export var Links = "Billboard-module--Links--0a641";
export var Links__Link = "Billboard-module--Links__Link--ff2c9";
export var MediaBlock = "Billboard-module--MediaBlock--820d8";